module.exports = __webpack_public_path__ + "static/media/mergers and acquisition.0ac04306.jpg";